import { React, Fragment, useState, useEffect, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/update_profile/actions";
import {
  addWorkExpRequest,
  resetData,
} from "../../../redux/jobseeker/work_experience/actions";
import DatePicker from "react-datepicker";
import { showToast } from "../../Common/Toast";
import { fetchCompanyRequest } from "../../../redux/company/actions";
import CreatableSelect from "react-select/creatable";
import { convertNumberToWords, handleNumberInput, countWords } from "../../Common/CommonFunction";
const Workexperiencemodal = (props) => {
  const dispatch = useDispatch();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [errors, setErrors] = useState({});
  /**
   * set default form field values
   */

  const [formData, setFormData] = useState({
    work_exp_id: props.data.id || "",
    designation: props.data.designation || "",
    organization: props.data.organization || "",
    job_profile: props.data.job_description || "",
    current_company: props.data.current_company || "",
    notice_period: props.data.notice_period || "",
    started_working_from: props.data.started_working_from
      ? new Date(props.data.started_working_from)
      : null,

    worked_till: props.data.worked_till
      ? new Date(props.data.worked_till)
      : null,
    current_salary: props.data.current_salary || "",
  });

  // const handleFormData = (data) => {
  //   if (data.id === "") {
  //     dispatch(addWorkExperience(data));
  //     setTimeout(() => {
  //       dispatch(fetchJobseekerDataRequest());
  //     }, 900);
  //     setTimeout(() => {
  //       props.toggleModal();
  //     }, 1100);
  //   } else {
  //     dispatch(updateWorkExperience(data));
  //     setTimeout(() => {
  //       dispatch(fetchJobseekerDataRequest());
  //     }, 900);
  //     setTimeout(() => {
  //       props.toggleModal();
  //     }, 1100);
  //   }
  // };

  /**
   * handle form submit when all data is valid
   */

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    if (validate()) {
      // Format the data before logging or dispatching

      const formattedData = {
        work_exp_id: formData.work_exp_id || "",
        designation: formData.designation || "",
        organization_id: formData.organization.value || "",
        organization: formData.organization.label || "",
        is_new: formData.organization.__isNew__ || false,
        job_description: formData.job_profile || "",
        current_company: formData.current_company || "",
        notice_period:
          (formData.current_company == "YES" && formData.notice_period) || "",
        started_working_from: formData.started_working_from || "",
        worked_till: formData.worked_till || "",
        current_salary: "",
      };

      dispatch(addWorkExpRequest(formattedData));
    }
  };

  // validate form data

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.designation) {
      errors.designation = "Designation is required";
      isValid = false;
    }

    if (!formData.organization) {
      errors.organization = "Organization is required";
      isValid = false;
    }
    if (!formData.job_profile) {
      errors.job_profile = "Job profile is required";
      isValid = false;
    } else {
      // Require at least one alphabet character (A-Z or a-z)
      const hasAlphabet = /[A-Za-z]/.test(formData.job_profile);
      if (!hasAlphabet) {
        errors.job_profile = "Job profile must contain at least one alphabet character."; // Added by Aman Maurya
        isValid = false;
      }
      // Minimum length check (15 characters)
      if (formData.job_profile.length < 15) {
        errors.job_profile = "Job profile must be at least 15 characters.";
        isValid = false;
      }
    }

    // Check if current_company is YES
    if (formData.current_company === "YES") {
      // Validate Notice Period
      if (!formData.notice_period) {
        errors.notice_period = "Notice period is required";
        isValid = false;
      } else if (isNaN(formData.notice_period)) {
        errors.notice_period = "Notice period must be a number";
        isValid = false;
      }
    }

    // Validate Started Working From date
    if (!formData.started_working_from) {
      errors.started_working_from = "Work from is required";
      isValid = false;
    } else {
      const currentDate = new Date();
      if (formData.started_working_from > currentDate) {
        errors.started_working_from = "Started Working From date cannot be greater than current date.";
        isValid = false;
      }
      if (formData.current_company === "NO" && formData.worked_till) {
        if (formData.started_working_from > formData.worked_till) {
          errors.started_working_from = "Started Working From date cannot be greater than Worked Till date.";
          isValid = false;
        }
      }

      const startedWorkingFrom = new Date(formData.started_working_from);
      const dobDate = new Date(props.dob); // props.dob = "1993-07-28"
      if (startedWorkingFrom < dobDate) {
        errors.started_working_from = "Started Working From date cannot be before Date of Birth.";
        isValid = false;
      }

      console.log("dattaww", formData.worked_till, "dob", props.dob);
    }



    if (formData.current_company === "NO") {
      if (!formData.worked_till) {
        errors.worked_till = "Work till is required";
        isValid = false;
      }
    }
    // CTC field hidden — optional / not collected here

    setErrors(errors);
    return isValid;
  };

  //handle onchange on form fields to remove errors

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    // Clear the error message when input changes
    let error = "";

    setErrors({ ...errors, [name]: error });

    if (name === "current_company" && value === "YES") {
      setFormData({
        ...formData,
        worked_till: new Date(),
        current_company: "YES",
      });
    } else if (name === "current_company" && value === "NO") {
      // Clear end date so the user picks it (do not auto-fill today).
      setFormData({
        ...formData,
        worked_till: null,
        current_company: "NO",
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // handle date chage
  const handleWorkFromDateChange = (date) => {
    const updatedErrors = { ...errors, started_working_from: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, started_working_from: date });

    const currentDate = new Date();
    // Check if current_company is YES
    if (formData.current_company === "YES") {
      if (date && date > currentDate) {
        updatedErrors.started_working_from = "Started Working From date cannot be greater than current date.";
      }
    } else if (formData.current_company === "NO") {
      // Check if worked_till is defined
      if (date && formData.worked_till && date > formData.worked_till) {
        updatedErrors.started_working_from = "Started Working From date cannot be greater than Worked Till date.";
      }
    }


  };
  const handleWorkTillDateChange = (date) => {
    const updatedErrors = { ...errors, worked_till: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, worked_till: date });
    // Validate the date comparison
    if (date && formData.started_working_from && date < formData.started_working_from) {
      updatedErrors.started_working_from = "Started Working From date cannot be greater than Worked Till date.";
    }
  };

  console.log("fd", formData);

  const addWorkExpReducerData = useSelector((state) => state.addWorkExpReducer);
  useEffect(() => {
    console.log("srd", addWorkExpReducerData);
    if (addWorkExpReducerData.status && addWorkExpReducerData.message != "") {
      props.toggleModal();
    } else if (
      addWorkExpReducerData.status == false &&
      addWorkExpReducerData.message != ""
    ) {
      // props.toggleModal();
    }
  }, [addWorkExpReducerData]);

  let companyReducerData = useSelector((state) => state.companyReducer);
  let companyData = companyReducerData.data.data;

  useEffect(() => {
    // Check if companyData is valid and not empty
    if (companyData && companyData.length > 0) {
      setCompanyOptions(companyData);
    }
  }, [companyData]); // Update state when companyData changes

  const handleCompanyFocus = () => {
    const fetchData = async () => {
      try {
        const keyword = "";
        dispatch(fetchCompanyRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  };

  const handleCompanyInputChange = useCallback((inputValue) => {
    const fetchData = async () => {
      try {
        dispatch(fetchCompanyRequest(inputValue));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleCompanyChange = (selectedOption) => {
    const updatedErrors = { ...errors, organization: "" };
    setErrors(updatedErrors);

    setFormData({ ...formData, organization: selectedOption });
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-lg"
    >
      <Form className="theme-form" onSubmit={handleSubmit}>
        <ModalHeader className="border-0" toggle={props.toggleModal}>
          <h4>
            {" "}
            {props.data.id ? "Edit Work Experience" : "Add Work Experience"}
          </h4>
        </ModalHeader>
        <ModalBody className="pt-0">
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Designation
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="designation"
                  placeholder="Enter your designation"
                  className="form-control form-control-sm"
                  value={formData.designation}
                  maxLength={50}
                  onChange={(e) => {
                    const { value } = e.target;

                    // Validates if the input value contains only alphabetic characters (and spaces)
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Call your existing handleChange function
                    } else {
                      // Optionally, set an error message or provide feedback
                      const updatedErrors = {
                        ...errors,
                        designation: "Only alphabetic characters are allowed.",
                      };
                      setErrors(updatedErrors);
                    }
                  }}
                />
                {errors.designation && (
                  <small className="text-danger">{errors.designation}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Organization
                  <span className="text-danger">*</span>
                </Label>
                <CreatableSelect
                  isClearable
                  className=""
                  options={companyOptions}
                  isLoading={companyReducerData.isLoading}
                  placeholder="Select Company"
                  value={formData.organization}
                  onChange={handleCompanyChange}
                  onInputChange={handleCompanyInputChange}
                  // styles={{
                  //   control: (provided, state) => ({
                  //     ...provided,
                  //     backgroundColor: "#f3f3ff",
                  //     border: "1px solid #ccc",
                  //     borderRadius: "4px",
                  //     height: "46px", // Adjust height as needed
                  //     padding: "0px", // Adjust padding as needed
                  //     boxShadow: state.isFocused
                  //       ? "0 0 0 2px rgba(0, 123, 255, 0.2)"
                  //       : "none",
                  //     "&:hover": {
                  //       borderColor: "#999",
                  //     },
                  //   }),
                  // }}
                  onFocus={handleCompanyFocus}
                />
                {errors.organization && (
                  <small className="text-danger">{errors.organization}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Is this your current company?
                  <span className="text-danger">*</span>
                </Label>
                <FormGroup>
                  <Label check>
                    <Input
                      checked={formData.current_company == "YES"}
                      type="radio"
                      name="current_company"
                      value="YES"
                      onChange={handleChange}
                    />{" "}
                    Yes
                  </Label>
                  <Label check className="ms-3">
                    <Input
                      type="radio"
                      name="current_company"
                      value="NO"
                      onChange={handleChange}
                      checked={formData.current_company == "NO"}
                    />{" "}
                    No
                  </Label>
                </FormGroup>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Started Working From
                  <span className="text-danger">*</span>
                </Label>
                <DatePicker
                  showYearDropdown
                  showMonthDropdown
                  className="form-control form-control-sm mb-0"
                  selected={formData.started_working_from}
                  onChange={handleWorkFromDateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Enter work from"
                  dropdownMode="select"
                />
                {errors.started_working_from && (
                  <small className="text-danger">
                    {errors.started_working_from}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col
              md={6}
              className={formData.current_company != "NO" ? "d-none" : ""}
            >
              <FormGroup>
                <Label>
                  Worked Till
                  <span className="text-danger">*</span>
                </Label>
                <DatePicker
                  showYearDropdown
                  showMonthDropdown
                  className="form-control form-control-sm mb-0"
                  selected={formData.worked_till}
                  onChange={handleWorkTillDateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Enter work till"
                  disabled={formData.current_company == "YES"}
                  dropdownMode="select"
                />
                {errors.worked_till && (
                  <small className="text-danger">{errors.worked_till}</small>
                )}
              </FormGroup>
            </Col>
            <Col
              md={6}
              className={formData.current_company != "YES" ? "d-none" : ""}
            >
              <FormGroup>
                <Label>
                  Notice Period (In Days) <span className="text-danger">*</span>
                </Label>
                <Input
                  //  type="number"
                  name="notice_period"
                  className="form-control form-control-sm"
                  placeholder="Enter notice period"
                  value={formData.notice_period}
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 365)}
                />
                {errors.notice_period && (
                  <small className="text-danger">{errors.notice_period}</small>
                )}
              </FormGroup>
            </Col>
            {/* CTC — commented out per product request; backend accepts empty current_salary
            <Col md={formData.current_company != "YES" ? 6 : 6}>
              <FormGroup>
                <Label>
                  CTC <span className="text-danger">*</span>
                </Label>
                <Input
                  name="current_salary"
                  className="form-control form-control-sm"
                  placeholder="Enter current salary"
                  value={formData.current_salary}
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 990000000)}
                />
                {formData.current_salary && !isNaN(formData.current_salary) && (
                  <small className="text-muted text-capitalize">
                    {convertNumberToWords(formData.current_salary)}
                  </small>
                )}
                {errors.current_salary && (
                  <small className="text-danger">{errors.current_salary}</small>
                )}
              </FormGroup>
            </Col>
            */}
            <Col md={12}>
              <FormGroup>
                <Label>
                  Describe Your Job Profile
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  name="job_profile"
                  rows="5"
                  placeholder="Enter job profile description"
                  value={formData.job_profile}
                  onChange={handleChange}
                  maxLength={600}
                />
                <small className="text-muted">
                  Words: {countWords(formData.job_profile)}
                </small>
                {errors.job_profile && (
                  <small className="text-danger">{errors.job_profile}</small>
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={props.toggleModal}>
            Close
          </Button>
          <Button
            disabled={addWorkExpReducerData.isLoading}
            color="primary"
            type="submit"
          >
            {props.data.id ? "Update" : "Add"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default Workexperiencemodal;
